var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCusd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#45CD85",
    d: "M14.807 5.593c.48.043.977.128 1.478.266V7.22c-.257-.188-.891-.57-2.07-.57s-1.384.506-1.341.763c-.034.116.086.399.814.6c.159.043.352.078.574.12c1.119.202 2.88.527 2.88 2.229c0 1.178-.99 1.89-2.335 2.036l.15.887h-1.329l.142-.883a6.5 6.5 0 0 1-2.199-.617v-1.423c.609.386 4.05 1.598 4.23 0c.056-.523-.664-.677-1.526-.866c-1.213-.257-2.704-.583-2.704-2.078c0-1.123.926-1.702 2.194-1.822l-.137-.883h1.333l-.15.879zm-3.236 11.55a4.29 4.29 0 0 0 3.93-2.572h1.371a5.571 5.571 0 1 1-7.015-7.015v1.371a4.286 4.286 0 0 0 1.714 8.216"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCusd);
export default __webpack_public_path__ + "static/media/cusd.3507f385baa92ceec9b19ac41010df0b.svg";
export { ForwardRef as ReactComponent };